import { countries } from '../index';
export function currentLanguage(wallet, browserLanguage) {
    // @ts-ignore
    return wallet ? (localStorage.getItem(`currentLanguage#${wallet}`) ?? browserLanguage) : browserLanguage;
}
export function supportedLocale(desiredLocale) {
    return [desiredLocale, desiredLocale.split('-')[0], 'en'].find((locale) => ['en', 'es', 'pt', 'bg', 'it', 'de', 'fr', 'tr', 'hi', 'ca'].indexOf(locale) !== -1);
}
export const supportedLanguageTags = () => {
    return [
        { name: 'language_tag.es', localName: 'Español', value: 'es' },
        { name: 'language_tag.en', localName: 'English', value: 'en' },
        { name: 'language_tag.pt', localName: 'Português', value: 'pt' },
        { name: 'language_tag.bg', localName: 'български', value: 'bg' },
        { name: 'language_tag.it', localName: 'Italiano', value: 'it' },
        { name: 'language_tag.de', localName: 'Deutsch', value: 'de' },
        { name: 'language_tag.fr', localName: 'Français', value: 'fr' },
        { name: 'language_tag.tr', localName: 'Türkçe', value: 'tr' },
        { name: 'language_tag.hi', localName: 'हिंदी', value: 'hi' },
        { name: 'language_tag.ca', localName: 'Català', value: 'ca' },
    ];
};
export const getPhoneAreaCodes = () => {
    const countryUniqueAreaCode = new Set();
    countries.forEach((c) => {
        countryUniqueAreaCode.add(c.area_code);
    });
    return Array.from(countryUniqueAreaCode);
};
//# sourceMappingURL=language.js.map